<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <h3 mat-dialog-title>Mudar Perfil</h3>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <div fxLayout="row wrap" fxLayoutAlign="center center">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex="100" >
                    <mat-label>Perfil</mat-label>
                    <mat-select 
                        placeholder="Perfil"
                        [formControl]="role_id"
                        name="role_id"
                        [disabled] = "true">
                        <mat-option *ngFor="let role of listRoles"
                            [value]="role.id">{{role.name}}</mat-option>
                    </mat-select>
                    <mat-spinner diameter="20" *ngIf="loadingSpinnerRole"></mat-spinner> 
                </mat-form-field>
            </div>
        </div>
     
        <div fxLayout="row wrap" fxLayoutAlign="center center">
            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" floatLabel="always"  fxFlex="100">
                    <mat-label>Tipo de Usuário</mat-label>
                    <mat-select placeholder="Tipo de Usuário"
                                [formControl]="tipo_usuario_id"
                                name="tipo_usuario_id" >
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option *ngFor="let tipoUsuario of listTipoUsuario" [value]="tipoUsuario.id">{{tipoUsuario.nome}}</mat-option>
                    </mat-select>
                    <mat-spinner diameter="20" *ngIf="loadingSpinnerTipoUsuario"></mat-spinner>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
        <button mat-button (click)="filtrar()" tabindex="-1">Alterar</button>
    </div>
</div>
